import { ApplicationInsights, ITelemetryItem } from "@microsoft/applicationinsights-web";

const connectionString = process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;

let appInsights: ApplicationInsights | null = null;

if (connectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: false,
      disableAjaxTracking: false,
      disableFetchTracking: false,
      enableCorsCorrelation: true,
    },
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((item: ITelemetryItem) => {
    item.tags = item.tags || {};
    item.tags["ai.cloud.role"] = "qft-frontend";
  });

  window.addEventListener("error", (event) => {
    trackException(event.error || new Error(event.message), {
      source: "window.error",
      filename: event.filename || "unknown",
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason instanceof Error
      ? event.reason
      : new Error(typeof event.reason === "string" ? event.reason : "Unhandled promise rejection");
    trackException(reason, { source: "window.unhandledrejection" });
  });
}

export function isTelemetryEnabled(): boolean {
  return !!appInsights;
}

export function trackPageView(name: string, uri?: string): void {
  if (!appInsights) return;
  appInsights.trackPageView({ name, uri });
}

export function trackEvent(
  name: string,
  properties?: Record<string, string>,
  measurements?: Record<string, number>
): void {
  if (!appInsights) return;
  appInsights.trackEvent({ name }, properties, measurements);
}

export function trackMetric(name: string, average: number, properties?: Record<string, string>): void {
  if (!appInsights) return;
  appInsights.trackMetric({ name, average }, properties);
}

export function trackException(error: unknown, properties?: Record<string, string>): void {
  if (!appInsights) return;
  const exception = error instanceof Error
    ? error
    : new Error(typeof error === "string" ? error : "Unknown frontend exception");
  appInsights.trackException({ exception, properties });
}
